// Sourced from @spectrum-css/tokens' light-scale values (red-900, orange-900,
// green-900, blue-900, gray-700, orange-1100) rather than picked ad hoc, so
// the avatar palette stays a Spectrum hue instead of a hand-tuned brand color.
// Deliberately static (not theme-adaptive): this is a swatch/chip background
// that must stay dark enough for the fixed white initials text in both light
// and dark app mode — Spectrum's dark-mode steps for these scales trend
// lighter (built for text/icon-on-dark-background contrast, not the reverse),
// which would actively hurt readability here, so both modes render from the
// same light-scale value on purpose.
const AVATAR_COLORS = ['#D73220', '#C24E00', '#05834E', '#3B63FB', '#505050', '#903300'];

export function pickColor(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}

export function makeInitialSrc(initials: string, bg: string): string {
  const fontSize = initials.length > 1 ? 16 : 20;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><circle cx="20" cy="20" r="20" fill="${bg}"/><text x="20" y="26" text-anchor="middle" font-size="${fontSize}" font-weight="600" font-family="sans-serif" fill="#fff">${initials}</text></svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

/** Returns up to two uppercase initials: first char of first word + first char of last word.
 *  Falls back to the first char of the email, then "?" if nothing is available.
 */
export function getInitials(name: string | undefined, email: string): string {
  const trimmed = name?.trim();
  if (trimmed) {
    const words = trimmed.split(/\s+/).filter(Boolean);
    if (words.length >= 2) {
      return (words[0][0] + words[words.length - 1][0]).toUpperCase();
    }
    // Single word: use first two letters if available, else one
    return words[0].slice(0, 2).toUpperCase();
  }
  return (email.trim().charAt(0) || '?').toUpperCase();
}
